import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
const MobileMenuItem = ({ item,closeMenu }) => {
    const navigate = useNavigate();
      const [isMenuOpen, setIsMenuOpen] = useState(false);
    
        const toggleMenu = () => {
            setIsMenuOpen(prev => !prev);
        };
    const handleNavigation = (event,path) => {
        if(path==="#"){
            setIsMenuOpen(prev => !prev);
            event.preventDefault();
        }else{
            navigate(path);
            if (typeof closeMenu === "function") {
                closeMenu();
            }
        }
       
         // Navigate to the selected path
        // closeMenu(); // Close the menu after navigation
    };
    return (
        <li  className={`menu-item menu-item-type-post_type menu-item-object-page menu-item-2566 ${isMenuOpen ? "qodef--opened" : ""}`}>
            <a  role='button'  onClick={(e) => handleNavigation(e,item.link)}>
                <span className="qodef-menu-item-text">
                    {item.text}
                    {item?.children?.length > 0 && (
                        <svg  className={`qodef-svg--menu-arrow qodef-menu-item-arrow ${isMenuOpen ? "rotated" : ""}`} xmlns="http://www.w3.org/2000/svg" width="12.643" height="12.642" viewBox="0 0 12.643 12.642">
                            <g fill="none" stroke="currentColor">
                                <path d="m5.968.353 5.968 5.968-5.968 5.967"/>
                                <path d="M11.935 6.32H0"/>
                            </g>
                        </svg>
                    )}
                </span>
            </a>
            {item?.children?.length > 0 && (
                <div className="qodef-drop-down-second">
                    <div className="qodef-drop-down-second-inner" >
                        <ul className="sub-menu" style={{display:isMenuOpen?"block":"none"}}>
                            {item?.children?.map(child => (
                                <MobileMenuItem key={child.id} item={child} closeMenu={closeMenu} />
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </li>
    );
};

export default MobileMenuItem;